<template>
	<div class="man">
		<router-view class="routebg"></router-view>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>
	.man{
		width: 100%;
		box-sizing: border-box;
		min-height: calc(100vh - 56px - 325px);
		background-color: rgba(116, 220, 220, 0.27);
	}
	.mans{
		min-height: calc(100vh - 56px);
		// background-color: #F1F9F8;
	}
	
	.routebg{
		background: url('../static/back.png') no-repeat;
		background-size: 100%;
		min-height: calc(100vh - 56px - 325px);
		box-sizing: border-box;
	}
</style>